import { zipObject, range, map } from "lodash/fp";
import { rgba } from "polished";
const opacities = [0, 0.02, 0.04, 0.09, 0.15, 0.25, 0.45, 0.65, 0.85, 1];
const color = {
  ...zipObject(
    range(0, 10).map((i) => `black${i + 1}`),
    map((opacity) => rgba("black", opacity), opacities)
  ),
  ...zipObject(
    range(0, 10).map((i) => `gray${i + 1}`),
    map((opacity) => rgba("black", opacity), opacities)
  ),
  ...zipObject(
    range(0, 10).map((i) => `blue${i + 1}`),
    [
      "#e9f3f7",
      "#d8e4eb",
      "#a9cade",
      "#7db0d1",
      "#5695c4",
      "#337ab7",
      "#215991",
      "#133c6b",
      "#092345",
      "#040e1f"
    ]
  ),
  ...zipObject(
    range(0, 10).map((i) => `green${i + 1}`),
    [
      "#ebfaec",
      "#ceedd2",
      "#9fe0aa",
      "#74d487",
      "#4ec76a",
      "#2aba51",
      "#1b943f",
      "#0e6e2e",
      "#06471e",
      "#02210f"
    ]
  ),
  ...zipObject(
    range(0, 10).map((i) => `monochrome${i + 1}`),
    [
      "#ffffff",
      "#fafafa",
      "#f5f5f5",
      "#e8e8e8",
      "#d9d9d9",
      "#bfbfbf",
      "#8c8c8c",
      "#595959",
      "#262626",
      "#000000"
    ]
  ),
  ...zipObject(
    range(0, 10).map((i) => `red${i + 1}`),
    [
      "#fff1f0",
      "#ffdfde",
      "#ffb5b5",
      "#fc8b8f",
      "#f05d67",
      "#e43546",
      "#bd2237",
      "#961429",
      "#70091e",
      "#4a0515"
    ]
  ),
  ...zipObject(
    range(0, 10).map((i) => `white${i + 1}`),
    map((opacity) => rgba("white", opacity), opacities)
  ),
  ...zipObject(
    range(0, 10).map((i) => `yellow${i + 1}`),
    [
      "#fffcf0",
      "#fff7db",
      "#ffebb3",
      "#ffdc8a",
      "#ffca61",
      "#f7af37",
      "#d18c24",
      "#ab6a15",
      "#854b09",
      "#5e3206"
    ]
  )
};
const defaultTheme = {
  breakpoint: {
    sm: 600,
    md: 900,
    lg: 1200
  },
  borderColor: color.monochrome4,
  controlBorderColor: color.monochrome5,
  color: {
    default: color.gray8,
    ...color,
    layer: {
      teal: {
        fill: "#57d8bd",
        outline: "#2a8c7e"
      },
      yellow: {
        fill: "#ffc34b",
        outline: "#b37922"
      },
      green: {
        fill: "#3ece65",
        outline: "#1a823d"
      },
      purple: {
        fill: "#bb4cac",
        outline: "#6e2269"
      },
      red: {
        fill: "#f8495a",
        outline: "#ab2038"
      }
    }
  },
  colors: zipObject(
    range(0, 10).map((i) => `gray${i + 1}`),
    range(0, 10).map((i) => ({
      hex: color[`monochrome${i + 1}`],
      rgba: color[`gray${i + 1}`]
    }))
  ),
  fontFamily: {
    default: [
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "PingFang SC",
      "Hiragino Sans GB",
      "Microsoft YaHei",
      "Helvetica Neue",
      "Helvetica",
      "Arial",
      "sans-serif",
      "Apple Color Emoji",
      "Segoe UI Emoji",
      "Segoe UI Symbol"
    ].join(",")
  },
  fontSize: {
    default: 12,
    xs: 8,
    sm: 10,
    md: 12,
    lg: 14,
    xl: 20,
    xxl: 24,
    xxxl: 32
  },
  fontWeight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900
  },
  lineHeight: {
    default: "20px",
    xs: "16px",
    sm: "18px",
    md: "20px",
    lg: "22px",
    xl: "28px",
    xxl: "32px",
    xxxl: "40px"
  }
};
export {
  defaultTheme
};
